import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
    IonButton, IonCard, IonCardHeader, IonCardTitle, IonCol, IonContent, IonGrid, IonIcon, IonInput, IonItem, IonLabel,
    IonRow, IonText, IonTitle
} from '@ionic/react';
import { checkmarkCircleOutline, closeCircleOutline } from 'ionicons/icons';

import { ABMClientsDefaultStateI } from '../../store/ABMClients/ABMClientsReducer';
import { GetABMClients } from '../../store/ABMClients/ABMClientsActions';
import { GetABMKpisGroups } from '../../store/ABMMetric/ABMKpisGroups/ABMKpisGroupsActions';

import ApiRequestor from '../../api_access/ApiRequestor';

import './ABMMetric.css';
import Modal from '../Modal/Modal';

type KpiGroupData = {
    client: string;
    name: string;
    legend :string;
}

interface Props extends StateTypes, dispatchTypes {
    backToTable: () => void
    seeKpis: (kpiGroup: any) => void
}

const AddGroupsABMKpis: React.FC<Props> = (props): JSX.Element => {

    const [kpisGroupData, setKpisGroupData] = useState<KpiGroupData>({
        client: '',
        name: '',
        legend: '',
    })
    const [clientInvalid, setClientInvalid] = useState(false)
    const [internId, setInternId] = useState();
    const [showModalAddGroups, setShowModalAddGroups] = useState(false);
    const [errors, setErrors] = useState({ nombre: '',legend: ''});
    const nameRegex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ]+(\s[a-zA-ZáéíóúÁÉÍÓÚñÑ]+)*$/;

    useEffect(() => {
        props.getClients()
    }, [])

    useEffect(() => {
        if (props.ABMClients.loading === false && props.ABMClients.abmclients) {
            props.ABMClients.abmclients.map((client: any) => {
                if (sessionStorage.getItem("client") === client.service_name) {
                    setInternId(client.service_id)
                }
            })
        }
    }, [sessionStorage.getItem("client"), props.ABMClients.loading, props.ABMClients.abmclients])

    const saveData = (e: any) => {
        setKpisGroupData({
            ...kpisGroupData,
            [e.target.name]: e.detail.value!
        })
    }

    const validateForm = () => {
        if (!internId) {
            setClientInvalid(true)
        } else {
            setClientInvalid(false)
        }
        if (!kpisGroupData.name.trim()) {
            setErrors(prevErrors => ({
                ...prevErrors, 
                nombre: 'El campo "Nombre" no debe ser vacío'
            }))
            return false
        } else if(!nameRegex.test(kpisGroupData.name)){
            setErrors(prevErrors => ({
                ...prevErrors, 
                nombre: 'No se permiten números ni caracteres especiales, ni espacios al inicio o al final',
                legend: 'No se permiten números ni caracteres especiales, ni espacios al inicio o al final'
            }))
            return false
        } else{
            return true
        }
    }

    const createKpisGroup = async () => {

        validateForm()
        let valid = validateForm()

        if (internId && valid) {

            let data: any = {
                body: {
                    service_id: internId,
                    kpi_group_name: kpisGroupData.name,
                    kpi_legend: kpisGroupData.legend
                }
            }

            const response = await ApiRequestor.requestToApi('/swt-admin/kpi-groups', 'POST', data)
            if (response && response.status === 200) {
                props.getABMKpisGroups()
                setShowModalAddGroups(true)
            }
        } else {
            validateForm()
        }
    }

    const onModalDismiss = () => {
        setShowModalAddGroups(false)
        const data: any = {
            service_id: internId,
            kpi_group_name: kpisGroupData.name
        }
        props.seeKpis(data)
    }

    return (
        <div className="custom-content-scroll">
            <IonCard className="ABMKpisCardFormAdd">
                <IonCardHeader>
                    <IonTitle className="ABMKpisTitleKpi">ALTA GRUPO DE KPIS</IonTitle>
                </IonCardHeader>
                <IonGrid className='ABMKpisADD'>
                    <IonRow>
                        <IonCol>
                            <IonLabel className="ABMKpisLabelKpis">Cliente</IonLabel>
                            <IonItem lines='none'>
                                <IonInput
                                    placeholder="Seleccione el Cliente"
                                    className="ABMKpisSelectKpis"
                                    name='client'
                                    value={sessionStorage.getItem("client")}
                                    disabled>
                                </IonInput>
                            </IonItem>
                            <IonText><p className={clientInvalid ? "login-valid-text" : "ion-hide"}> Debe seleccionar un cliente</p></IonText>
                        </IonCol>
                        <IonCol sizeXl="6" sizeXs='12'>
                            <IonLabel className="ABMKpisLabelKpis">Nombre del Grupo de Kpis</IonLabel>
                            <IonItem lines='none'>
                                <IonInput
                                    className="ABMKpisInputKpis"
                                    type="text"
                                    placeholder="Nombre grupo Kpis"
                                    name='name'
                                    value={kpisGroupData.name}
                                    onIonChange={(e) => saveData(e)} />
                            </IonItem>
                            <IonText><p className={errors.nombre ? "login-valid-text" : "ion-hide"}>{errors.nombre}</p></IonText>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                    <IonCol sizeXl="6" sizeXs='12'>
                            <IonLabel className="ABMKpisLabelKpis">Leyenda del Grupo de Kpis</IonLabel>
                            <IonItem lines='none'>
                                <IonInput
                                    className="ABMKpisInputKpis"
                                    type="text"
                                    placeholder="Leyenda grupo Kpis"
                                    name='legend'
                                    value={kpisGroupData.legend}
                                    onIonChange={(e) => saveData(e)} />
                            </IonItem>
                            <IonText><p className={errors.legend ? "login-valid-text" : "ion-hide"}>{errors.legend}</p></IonText>
                        </IonCol>
                    </IonRow>
                    <IonRow className="ion-justify-content-center containerButtonKpis">
                        <IonButton className="ClassButtonKpis ABMKpisZoom" type="submit" fill="clear" onClick={createKpisGroup}>
                            <IonIcon icon={checkmarkCircleOutline} color="success" className="ABMKpisButton" />
                        </IonButton>
                        <IonButton className="ClassButtonKpis ABMKpisZoom" fill="clear" onClick={props.backToTable}>
                            <IonIcon icon={closeCircleOutline} color="danger" className="ABMKpisButton" />
                        </IonButton>
                    </IonRow>
                </IonGrid>
            </IonCard>


            <Modal
                modalConfirmation={{
                    textConfirmation: "Grupo de Kpis Creado Correctamente",
                    onDidDimissConfirmModal: onModalDismiss,
                    isOpenModalConfirm: showModalAddGroups,
                    onClickConfirmModal: onModalDismiss,
                }}
            />

        </div>
    )
}

//Redux state and actions dispatchers
interface StateTypes {
    ABMClients: ABMClientsDefaultStateI
}

const mapStatetoProps = (state: StateTypes) => {
    return {
        ABMClients: state.ABMClients
    }
}

interface dispatchTypes {
    getClients: () => void;
    getABMKpisGroups: () => void;
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        getClients: () => dispatch(GetABMClients()),
        getABMKpisGroups: () => dispatch(GetABMKpisGroups())
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(AddGroupsABMKpis);